// extracted by mini-css-extract-plugin
export default {"zeroList":"ZeroWaste_zeroList__DQqLC"};